import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  ProviderClass,
  UiZoneWidgetAttributeConfig,
  UiZoneWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { FormSubmitter } from '../../widgets/form-widgets/form-submitter/form-submitter.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-org-registration-number',
  templateUrl: './org-registration-number.component.html',
})
export class OrgRegistrationNumberComponent extends FormSubmitter implements OnInit {
  @Output() registrationNumberChange = new EventEmitter<string>();
  @Input() registrationNumber: string;
  public widgetConfig: UiZoneWidgetConfig;
  public registrationNumberForm: FormGroup;

  constructor(public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>, protected override store: Store) {
    super(store);
  }

  ngOnInit() {
    this.buildForm();
    this.listenToChanges();
  }

  private buildForm() {
    this.registrationNumberForm = new FormGroup({
      registrationNumber: new FormControl(this.registrationNumber ?? ''),
    });
    this.registrationNumberChange.emit(this.registrationNumberForm.value.registrationNumber);
  }

  private listenToChanges() {
    this.registrationNumberForm.valueChanges
      .pipe(takeUntil(this.destroy$), debounceTime(300), distinctUntilChanged())
      .subscribe((value) => {
        this.registrationNumberChange.emit(value.registrationNumber);
      });
  }
}
